<div class="container-fluid bg-light">

  <!--  ligne supérieure-->
  <div class="row bg-white py-3 px-5">
    <div class="col-6 fw-bold"><i class="bi bi-house-door fs-4"></i> {{ residency?.nom | uppercase }}</div>
    <div class="col-6 d-flex justify-content-end">
      <button class="blackBoxButton" [routerLink]="['/choix-residence']">Changer</button>
    </div>
  </div>
  @if (dataStoredInIndexedDb && residencyConstats.length > 0) {
    <!--  mon agenda-->
    <div class="row">
      <div class="col-11 mx-auto mt-4 light-turquoise-box p-2">
        <div class="d-flex justify-content-center">
          <div class="me-2"><i class="bi bi-calendar-event"></i></div>
          <div class="mx-5 fw-bold">Mon agenda</div>
          <div class="ms-2 blackSquare px-1"
               [routerLink]="['/inventory', 'display-inventory']">{{ residencyConstats.length ? residencyConstats.length : 0 }}
          </div>
        </div>
      </div>
    </div>
    <!--  ensemble des carrés-->
    <div class="row mt-4 mx-auto mx-xl-5">
      <div class="col-md-5  mx-auto d-flex align-items-stretch" [routerLink]="['/inventory', 'display-inventory']"
           [queryParams]="{displayedTypes: ['EDLE','EDLS']}">
        <div
          class="bg-white d-flex flex-column justify-content-center p-5 px-lg-3 rounded shadow hover-up my-3 flex-fill">
          <i class="bi bi-arrow-repeat mx-auto fs-4"></i>
          <div class="mx-auto text-center fw-bold">État des lieux</div>
          <div class="mx-auto text-center fw-bold">locataires</div>
        </div>
      </div>
    </div>
  } @else if (residencyConstats.length === 0) {
    <div class="text-center mt-5">
      <h4>Pas de constats disponibles pour cette résidence</h4>
      <button class="blackBoxButton mt-3" [routerLink]="['/choix-residence']">Choisir une autre résidence</button>
    </div>
  } @else if (!dataStoredInIndexedDb) {
    <div class="mt-5 d-flex justify-content-center">
      <app-spinner color="#e1b600"></app-spinner>
    </div>
  }
</div>

